import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { createScreenPoint as t } from "../../../core/screenUtils.js";

function e(t, e) {
  return Math.abs(e.x - t.x) + Math.abs(e.y - t.y);
}

function n(t, e) {
  var n = e.x - t.x,
      r = e.y - t.y;
  return Math.sqrt(n * n + r * r);
}

function r(e, n) {
  if (n ? (n.radius = 0, n.center.x = 0, n.center.y = 0) : n = {
    radius: 0,
    center: t()
  }, 0 === e.length) return n;
  if (1 === e.length) return n.center.x = e[0].x, n.center.y = e[0].y, n;

  if (2 === e.length) {
    var _e = _slicedToArray(e, 2),
        _t = _e[0],
        _r = _e[1],
        _c = _r.x - _t.x,
        _s = _r.y - _t.y;

    return n.radius = Math.sqrt(_c * _c + _s * _s) / 2, n.center.x = (_t.x + _r.x) / 2, n.center.y = (_t.y + _r.y) / 2, n;
  }

  var r = 0,
      c = 0;

  for (var _t2 = 0; _t2 < e.length; _t2++) {
    r += e[_t2].x, c += e[_t2].y;
  }

  r /= e.length, c /= e.length;
  var s = e.map(function (t) {
    return t.x - r;
  }),
      x = e.map(function (t) {
    return t.y - c;
  });
  var o = 0,
      y = 0,
      a = 0,
      h = 0,
      l = 0,
      u = 0,
      i = 0;

  for (var _t3 = 0; _t3 < s.length; _t3++) {
    var _e2 = s[_t3],
        _n = x[_t3],
        _r2 = _e2 * _e2,
        _c2 = _n * _n;

    o += _r2, y += _c2, a += _e2 * _n, h += _r2 * _e2, l += _c2 * _n, u += _e2 * _c2, i += _n * _r2;
  }

  var f = .5 * (h + u),
      g = .5 * (l + i),
      M = o * y - a * a,
      d = (f * y - g * a) / M,
      m = (o * g - a * f) / M,
      p = t(d + r, m + c);
  return {
    radius: Math.sqrt(d * d + m * m + (o + y) / e.length),
    center: p
  };
}

export { n as euclideanDistance, r as fitCircleLSQ, e as manhattanDistance };